<template>

  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
            page-title="Evaluador"
            directory="Crear / Editar"
            :icon="'grid'"
        />
      </div>
    </div>


    <app-overlay-loader v-if="preloader"/>
    <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/evaluator/maintenance/storeDetail/${inputs.id}`
            : `/evaluator/maintenance/storeDetail`
        "
    >


      <div class="row" v-if="show">
        <div class="col-12 mb-3">
          <button
              type="button"
              class="btn btn-secondary mr-2"
              @click="returnPage()"
          >
            Regresar
          </button>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Codigo<b class="text-danger ml-2" style="font-size: 18px !important">*</b></label>
            <app-input
                type="text"
                v-model="inputs.code"
                placeholder="Ingrese el codigo"
                :required="true"
            />
          </div>
        </div>


        <div class="col-md-6">
          <div class="form-group">
            <label>Categoría<b class="text-danger ml-2" style="font-size: 18px !important">*</b></label>
            <app-input
                type="select"
                v-model="inputs.type_id"
                :required="true"
                :list="evaluatorType"
                v-on:change="onChangeAccreditationArea"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Area<b class="text-danger ml-2" style="font-size: 18px !important">*</b></label>
            <app-input
                type="select"
                v-model="inputs.area_id"
                :list="accreditationAreaList"
                v-on:change="onChangeAccreditationArea"
                :required="true"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="inputs.type_id != 6">
          <div class="form-group">
            <label v-if="inputs.type_id != 6">Esquema<b class="text-danger ml-2" style="font-size: 18px !important">*</b></label>
            <app-input
                type="select"
                v-model="inputs.activity_id"
                :list="accreditationActivityLists"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="inputs.type_id == 6">
          <div class="form-group">
            <label>Sector<b class="text-danger ml-2" style="font-size: 18px !important">*</b></label>
            <app-input
                type="select"
                v-model="inputs.sector_id"
                :list="accreditationActivityLists"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="inputs.type_id != 6">
          <div class="form-group">
            <label> Normas de acreditación </label>
            <app-input
                type="select"
                v-model="inputs.rule_id"
                :list="accreditationRuleList"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="inputs.type_id == 6">
          <div class="form-group">
            <label> ALCANCE EN EL QUE SE ENCUENTRA CALIFICADO </label>
            <app-input
                type="search-select"
                v-model="inputs.scope_id"
                :list="accreditationScopeEvalList"
                @input="onChangeScopeQualified"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="inputs.type_id == 6">
          <div class="form-group">
            <label> DETALLES DEL ALCANCE </label>
            <app-input
                type="multi-select"
                :list="scopeDetails"
                :isAnimatedDropdown="true"
                v-model="details"
                :required="true"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="inputs.iaf_code">
          <div class="form-group">
            <label>CÓDIGO IAF/SUBCATEGORIA ALIMENTARIA (DC)</label>
            <app-input
                type="textarea"
                v-model="inputs.iaf_code"
                disabled
            />
          </div>
        </div>

      </div>

      <div class="row" v-if="show">
        <div class="col-md-6">
          <div class="form-group">
            <label>Estatus</label>
            <app-input
                type="radio-buttons"
                v-model="inputs.is_active"
                :list="isActive"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Fecha de habilitación</label>
            <app-input type="date" v-model="inputs.enable_date"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Actualización de calificación</label>
            <app-input type="date" v-model="inputs.rating_update"/>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Fecha de actualización de documentos</label>
            <app-input
                type="date"
                v-model="inputs.documentation_update_date"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Ultima evaluación de desempeño</label>
            <app-input type="date" v-model="last_evaluation"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Fecha para la siguiente evaluación</label>
            <app-input type="date" v-model="next_evaluation"/>
          </div>
        </div>

        <div class="col-md-6 d-flex align-items-center">
          <div class="form-group">
            <label>Vigencia</label>
            <h4 v-if="!last_evaluation" class="text-warning"><strong>PENDIENTE</strong>
            </h4>
            <h4 v-else-if="!isValidity" class="text-danger"><strong>VENCIDO</strong>
            </h4>
            <h4 v-else-if="isValidity" class="text-success"><strong>VIGENTE</strong>
            </h4>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Resultado de la evaluación</label>
            <app-input type="text" v-model="inputs.evaluation_result"/>
          </div>
        </div>

        <!--        <div class="col-md-6">-->
        <!--          <div class="form-group">-->
        <!--            <label>Evaluación de desempeño baja ( menor a 3)</label>-->
        <!--            <app-input-->
        <!--                type="text"-->
        <!--                v-model="inputs.performance_evaluation_low"-->
        <!--            />-->
        <!--          </div>-->
        <!--        </div>-->

        <!--        <div class="col-md-6">-->
        <!--          <div class="form-group">-->
        <!--            <label>Parametro evaluación de desempeño baja (menor a 3)</label>-->
        <!--            <app-input type="text" v-model="inputs.performance_parameter" />-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="col-md-12 mb-4">
          <div class="form-group">
            <label>Observaciones</label>
            <quill-editor :options="editorOption"
                          v-model="inputs.performance_planification_eval"
                          style="background: white; color: black;">
            </quill-editor>
          </div>
        </div>
      </div>
    </form>
    <hr/>
    <br/><br/>

    <low-performance-eval v-if="id || updateAux" :detailId="id" ref="lowPerformanceEval"/>

    <div class="row">
      <div class="col-12">
        <button
            type="button"
            class="btn btn-secondary mr-2"
            @click="returnPage()"
        >
          Regresar
        </button>
        <button type="button" class="btn btn-primary" @click="submit">
          Guardar
        </button>
      </div>
    </div>


  </div>
</template>

<script>
import {FormMixin} from "@/core/mixins/form/FormMixin.js";
import {ModalMixin} from "@/app/Mixins/ModalMixin";
import moment from "moment";
import * as actions from "../../apiURL";
import {axiosGet, axiosPatch, axiosPost} from "../../../../../../../resources/js/app/helpers/AxiosHelper";
import AppLibrary from "../../../../../../../resources/js/app/helpers/AppLibrary";
import lowPerformance from "./low-performance-evaluation/Index"
import {quillEditor} from "vue-quill-editor";


export default {
  mixins: [FormMixin, ModalMixin],
  extends: AppLibrary,
  components: {quillEditor, lowPerformance},
  name: "EvaluatorSetting",
  props: {
    id: String
  },
  data() {
    return {
      preloader: true,
      updateAux: false,
      last_evaluation: "",
      next_evaluation: "",
      isValidity: null,
      inputs: {
        is_active: 0,
        evaluator_id: localStorage.getItem("evaluator_id"),
      },
      details: [],
      scopeDetails: [],
      modalId: "config-modal-add-edit",
      scope: [
        {id: null, value: this.$t("select_option")},
        {
          id: "O",
          value: "SAE",
        },
        {
          id: "E",
          value: "Externo",
        },
      ],
      typeInstitution: [
        {id: null, value: this.$t("select_option")},
        {
          id: "PU",
          value: "Publica",
        },
        {
          id: "PR",
          value: "Privada",
        },
      ],
      isActive: [
        {
          id: 0,
          value: "Inhabilitado",
        },
        {
          id: 1,
          value: "Habilitado",
        },
      ],
      delayTimer: null,
      show: true,
      counter: "",
      provinceList: [],
      cantonList: [],
      accreditationActivityLists: [{id: "", value: this.$t("select_option")}],
      evaluatorType: [],
      accreditationAreaList: [],
      accreditationActivityList: [],
      accreditationRuleList: [],
      accreditationScopesList: [],
      accreditationScopesLists: [{id: "", value: this.$t("select_option")}],
      accreditationScopeEvalList: [],
      validity: "",
      firstRendered: true,
      editorOption: {
        modules: {
          toolbar: [
            [{size: ["small", false, "large", "huge"]}],
            ["bold", "italic", "underline"],
            [{align: []}],
            [{indent: "-1"}, {indent: "+1"}],
            [{color: []}, {background: []}],
            [{list: "ordered"}, {list: "bullet"}],
            ["clean"],
          ],
        },
        theme: "snow", // snow or bubble
      }
    };
  },
  created() {
    this.types();
    this.getDetail();
    //this.scopeDetails = []
  },
  computed: {
    cantons() {
      return [
        {id: null, value: this.$t("select_option")},
        ...this.$store.state.common.cantons,
      ];
    },

    detailId() {
      return this.inputs.id;
    }

  },
  watch: {
    "inputs.scope_id": function (){
      this.scopeDetails = [];
      if (this.inputs.scope_id){
        const url = `/masterData/evaluatorScope/data/details_by_scope/${this.inputs.scope_id}`;
        axiosGet(url).then(response=>{
          this.scopeDetails = response.data;
        })
      }

    },
    "inputs.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
          this.inputs.country_id
      );
    },

    "inputs.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(this.inputs.province_id);
    },
    "last_evaluation": function () {
      if (!this.firstRendered && this.last_evaluation) {
        this.preloader = true;
        const dateParsed = this.getDateFormatForBackend(this.last_evaluation);
        let url = `${actions.EVALUATOR_MAINTENANCE}/setting/add-years?size=3&date=${dateParsed}`;
        axiosGet(url).then(response => {
          this.next_evaluation = new Date(response.data.dateFuture.toString().concat('T00:00:00'));
          this.preloader = false;
          if (this.last_evaluation && this.next_evaluation) {
            const last = moment(this.last_evaluation).format('YYYY-MM-DD');
            const next = moment(this.next_evaluation).format('YYYY-MM-DD');
            const today = moment(new Date()).format('YYYY-MM-DD');
            this.isValidity = moment(today).isBetween(last, next);
          }
        })
      }
      this.firstRendered = false;
    },
    "next_evaluation": function () {
      if (this.last_evaluation && this.next_evaluation) {
        const last = moment(this.last_evaluation).format('YYYY-MM-DD');
        const next = moment(this.next_evaluation).format('YYYY-MM-DD');
        const today = moment(new Date()).format('YYYY-MM-DD');
        this.isValidity = moment(today).isBetween(last, next);
      }
    },
    "$store.state.common.countries": function () {
      if (this.inputs.i_country_id) {
        this.provinceList = this.$store.getters.getProvinces(
            this.inputs.i_country_id
        );
        this.cantonList = this.$store.getters.getCantons(
            this.inputs.org.i_province_id
        );
      }
    },
  },
  methods: {
    submit() {
      if (!this.inputs.code ||
          !this.inputs.type_id ||
          !this.inputs.area_id) {
            this.$toastr.e("Llenar los campos requeridos");
            return;
      }
      this.preloader = true;
      const data = {
        ...this.inputs,
        last_evaluation: this.last_evaluation ? this.getDateFormatForBackend(this.last_evaluation) : null,
        next_evaluation: this.next_evaluation ? this.getDateFormatForBackend(this.next_evaluation) : null,
        documentation_update_date: this.inputs.documentation_update_date ? this.getDateFormatForBackend(this.inputs.documentation_update_date) : null,
        enable_date: this.inputs.enable_date ? this.getDateFormatForBackend(this.inputs.enable_date) : null,
        rating_update: this.inputs.rating_update ? this.getDateFormatForBackend(this.inputs.rating_update) : null,
        'function': 'N/A',
        'scope_details': this.details.toString()
      }

      if (this.id || this.updateAux) {
        const id = this.id ? this.id : this.$store.state.evaluatorReview.detailId;
        const url = `${actions.EVALUATOR_MAINTENANCE}/storeDetail/${id.toString()}`
        //update
        axiosPatch(url, data).then(response => {
          this.$toastr.s(this.$t("updated_success"));
          this.preloader = false;
        })
      } else {
        //create
        const url = `${actions.EVALUATOR_MAINTENANCE}/storeDetail`
        this.updateAux = true;
        axiosPost(url, data).then(response => {
          this.$toastr.s(this.$t("updated_success"));
          //this.id = response.data.id.toString();
          const pathname = window.location.pathname;
          history.pushState(null, "", `${pathname}/${response.data.id.toString()}`)
          this.preloader = false;
          this.$store.commit('SET_DETAIL_ID', response.data.id.toString());
        })
      }

    },
    returnPage() {
      const id = localStorage.getItem("evaluator_id");
      window.location.href = `${actions.EVALUATOR_MAINTENANCE}/config/${id}`;
    },
    getDetail() {
      if (this.id) {
        let url = `${actions.EVALUATOR_MAINTENANCE}/showDetails/${this.id}`;
        axiosGet(url).then((response) => {
          this.inputs = response.data
          this.inputs.enable_date = this.inputs.enable_date ? new Date(this.inputs.enable_date.toString().concat('T00:00:00')) : "";
          this.inputs.documentation_update_date = this.inputs.documentation_update_date ? new Date(this.inputs.documentation_update_date.toString().concat('T00:00:00')) : "";
          this.next_evaluation = this.inputs.next_evaluation ? new Date(this.inputs.next_evaluation.toString().concat('T00:00:00')) : "";
          this.last_evaluation = this.inputs.last_evaluation ? new Date(this.inputs.last_evaluation.toString().concat('T00:00:00')) : "";
          this.inputs.rating_update = this.inputs.rating_update ? new Date(this.inputs.rating_update.toString().concat('T00:00:00')) : "";
          if (response.data.scope_details){
            this.details = response.data.scope_details.split(',').map(item=>Number(item));
          }
          this.accreditationScopesLists = [
            {id: "", value: this.$t("select_option")},
            ...this.accreditationScopesList.filter((item)=>{
              return item.parent == this.inputs.area_id
            })
          ];
          // this.accreditationActivityLists = [
          //   {id: "", value: this.$t("select_option")},
          //   ...this.accreditationActivityList.filter((item) => {
          //     return item.parent == this.inputs.area_id;
          //   }),
          // ];
          this.onChangeAccreditationArea();
          this.$store.commit('SET_DETAIL_ID', this.inputs.id);
          this.preloader = false;
        });
      } else {
        this.preloader = false;
        this.firstRendered = false;
      }

    },
    validateVigence() {
      var estado;
      if (this.selectedUrl) {
        let last_evaluation = moment(this.inputs.last_evaluation).format(
            "YYYY-MM-DD"
        );
        let next_evaluation = moment(this.inputs.next_evaluation).format(
            "YYYY-MM-DD"
        );
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
          dd = "0" + dd;
        }
        if (mm < 10) {
          mm = "0" + mm;
        }
        var today = yyyy + "-" + mm + "-" + dd;
        if (last_evaluation) {
          if (today >= last_evaluation && today <= next_evaluation) {
            estado = "Vigente";
          } else {
            estado = "Incativo";
          }
        }
        this.validity = estado;
      }
    },

    onChangeScopeQualified(){
      const scopeFound = this.accreditationScopeEvalList.find(item => item.id == this.inputs.scope_id);
      if (scopeFound){
        this.inputs.iaf_code = scopeFound.code_iaf_subcategory;
      }
    },

    types() {
      let url = `${actions.EVALUATOR_MAINTENANCE}/types`;
      axiosGet(url).then((response) => {
        this.evaluatorType = [
          {id: null, value: this.$t("select_option")},
          ...response.data,
        ];
      });

      let uri = `/accreditations/applications/options`;
      axiosGet(uri).then((response) => {
        this.accreditationAreaList = [
          {id: "", value: "Selecciona una opción"},
          ...response.data.accreditationAreas,
        ];

        this.accreditationActivityList = [
          {id: "", value: "Selecciona una opción"},
          ...response.data.accreditationActivitiesAll,
        ];
      });

      let urlRules = `/rules`;
      axiosGet(urlRules).then((response) => {
        this.accreditationRuleList = [
          {id: null, value: this.$t("select_option")},
          ...response.data.rules,
        ];

        this.accreditationScopesList = [
          {id: null, value: this.$t("select_option")},
          ...response.data.sector,
        ];

        this.accreditationScopeEvalList = [
          {id: null, value: this.$t("select_option")},
          ...response.data.eval_scopes,
        ];
      });
    },

    onChangeAccreditationArea() {

      const evalTypeFound = this.evaluatorType.find((item) => item.id == this.inputs.type_id);

      if (evalTypeFound && (evalTypeFound.code == 'E' || evalTypeFound.code == 'ET')){
        this.accreditationActivityLists = [
          {id: "", value: this.$t("select_option")},
          ...this.accreditationActivityList.filter((item) => {
            // return item.parent == this.inputs.area_id && item.type == evalTypeFound.code;
            return item.parent == this.inputs.area_id;
          }),
        ];

        // this.accreditationScopesLists = [
        //   {id: "", value: this.$t("select_option")},
        //   ...this.accreditationScopesList.filter((item)=>{
        //     return item.parent == this.inputs.area_id
        //   })
        // ];
      }else{
        this.accreditationActivityLists = [
          {id: "", value: this.$t("select_option")},
          ...this.accreditationActivityList.filter((item) => {
            return item.parent == this.inputs.area_id;
          }),
        ];

        // this.accreditationScopesLists = [
        //   {id: "", value: this.$t("select_option")},
        //   ...this.accreditationScopesList.filter((item)=>{
        //     return item.parent == this.inputs.area_id
        //   })
        // ];
      }

    },
    onKeyUpTaxid() {
      this.counter = this.inputs.taxid.length;
      if (this.inputs.taxid.length == 10 || this.inputs.taxid.length == 13) {
        if (this.inputs.taxid != null && !this.inputs.id) {
          clearTimeout(this.delayTimer);
          this.delayTimer = setTimeout(this.ckeckTaxid, 1000);
        }
      }
    },

    handleBlur(e) {
      if (this.inputs.taxid != null && !this.inputs.id) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(this.ckeckTaxid, 1000);
      }
    },

    ckeckTaxid() {
      this.preloader = true;
      clearTimeout(this.delayTimer);
      const url = `/evaluator/maintenance/user?taxid=${this.inputs.taxid}`;
      this.axiosGet(url)
          .then((response) => {
            if (response.status == 200) {
              const {data} = response;
              this.show = true;
              if (data) {
                const tmp = {
                  user_id: data.id,
                  first_name: data.first_name,
                  last_name: data.last_name,
                  phone: data.phone,
                  email: data.email,
                };
                this.inputs = {
                  ...this.inputs,
                  ...tmp,
                };
              }
            }
          })
          .catch(({error}) => {
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
          });
    },

    onKeyUpUsername() {
      if (this.inputs.taxid != null && !this.inputs.id) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(this.ckeckUsername, 1000);
      }
    },
    ckeckUsername() {
      this.preloader = true;
      clearTimeout(this.delayTimer);
      const url = `/evaluator/maintenance/user?username=${this.inputs.username}`;
      this.axiosGet(url)
          .then((response) => {
            if (response.status == 200) {
              this.uniqueUsername = response.data == "";
            }
          })
          .catch(({error}) => {
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
          });
    },

    onKeyUpEmail() {
      if (this.inputs.taxid != null && !this.inputs.id) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(this.ckeckEmail, 1000);
      }
    },
    ckeckEmail() {
      this.preloader = true;
      clearTimeout(this.delayTimer);
      const url = `/evaluator/maintenance/user?email=${this.inputs.email}`;
      this.axiosGet(url)
          .then((response) => {
            if (response.status == 200) {
              this.uniqueEmail = response.data == "";
            }
          })
          .catch(({error}) => {
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
          });
    },
  }
}
</script>

<style scoped>

</style>